<template>
  <Modal
    v-model="_value"
    width="300"
    title="查看/修改定位设备通道"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <scroll height="300px;">
    <div class="demo-split">
    <Form ref="loginForm" :model="positioningDeviceInfo" :rules="rules" style="display: inline;">
    </Form>
              <label>摄像头通道</label>
          <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
            <Checkbox  :disabled="!modify"
              :indeterminate="indeterminate"
              :value="checkAll"
              @click.prevent.native="handleCheckAll">全选</Checkbox>
          </div>

      <div>
          <CheckboxGroup v-model="checkAllGroup" @on-change="checkAllGroupChange">
            <Checkbox label="1" class="Checkbox" :disabled="!modify" v-model="positioningDeviceInfo.aisleOne"></Checkbox>
            <Checkbox label="2" class="Checkbox" :disabled="!modify" v-model="positioningDeviceInfo.aisleTwo"></Checkbox>
            <Checkbox label="3" class="Checkbox" :disabled="!modify" v-model="positioningDeviceInfo.aisleThree"></Checkbox>
            <Checkbox label="4" class="Checkbox" :disabled="!modify" v-model="positioningDeviceInfo.aisleFour"></Checkbox>
            <Checkbox label="5" class="Checkbox" :disabled="!modify" v-model="positioningDeviceInfo.aisleFive"></Checkbox>
            <Checkbox label="6" class="Checkbox" :disabled="!modify" v-model="positioningDeviceInfo.aisleSix"></Checkbox>
            <Checkbox label="7" class="Checkbox" :disabled="!modify" v-model="positioningDeviceInfo.aisleSeven"></Checkbox>
            <Checkbox label="8" class="Checkbox" :disabled="!modify" v-model="positioningDeviceInfo.aisleEight"></Checkbox>
            <Checkbox label="9" class="Checkbox" :disabled="!modify" v-model="positioningDeviceInfo.aisleNine"></Checkbox>
            <Checkbox label="10" class="Checkbox" :disabled="!modify" v-model="positioningDeviceInfo.aisleTen"></Checkbox>
          </CheckboxGroup>
      </div>

    </div>
    </scroll>
    <van-row style="text-align: right;">
<!--      <van-button size="small" style="margin-right: 3px;" @click="onPositioningDeviceFittingsDetailModal" type="primary">设备配件</van-button>-->
      <i-switch v-model="modify" @on-change="modifyChange" size="large">
        <span slot="open">保存</span>
        <span slot="close">修改</span>
      </i-switch>
    </van-row>
    <positioning-device-fittings-detail-modal v-model="PositioningDeviceFittingsDetailModal" :initValue="PositioningDeviceFittingsDetailModalId" @on-success="onSuccess"></positioning-device-fittings-detail-modal>
    <add-positioning-device-fittings-modal  v-model="AddPositioningDeviceFittingsModal" :initValue="AddPositioningDeviceFittingsModalId" :terminalNumValue="AddPositioningDeviceFittingsModalterminalNum" @on-positioningdevicefittings="onPositioningdevicefittings"></add-positioning-device-fittings-modal>
    <modify-positioning-device-service-datetime-modal v-model="modifyPositioningDeviceServiceDatetimeModal" :initValue="modifyPositioningDeviceServiceDatetimeId" @on-success="onSuccess"></modify-positioning-device-service-datetime-modal>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import ModifyPositioningDeviceServiceDatetimeModal from '@/views/im/components/modify-positioning-device-service-datetime-modal'
import AddPositioningDeviceFittingsModal from '@/views/im/components/add-positioning-device-fittings-modal'
import PositioningDeviceFittingsDetailModal from '@/views/im/components//positioning-device-fittings-detail-modal'
import {
  Cell,
  CellGroup,
  Field,
  Row,
  Col,
  Button,
  Dialog,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Picker,
  Popup,
  Divider,
  Collapse,
  CollapseItem,
  DatetimePicker,
  Tag,
  DropdownMenu,
  DropdownItem,
  Sticky,
  Icon,
  Search,
  PullRefresh,
  List,
  Loading,
  Toast,
} from 'vant'


Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast);

export default {
  name: 'positioningdeviceinfoaislemodal',
  components: {
    ModifyPositioningDeviceServiceDatetimeModal,
    PositioningDeviceFittingsDetailModal,
    AddPositioningDeviceFittingsModal
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    terminalNumRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: 'SIM卡号码不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  data () {
    return {
      // 多选
      indeterminate: false,
      checkAll: false,
      checkAllGroup: [],

      // 分割面板
      split1: 0.5,

      // 查看/修改设备配件
      PositioningDeviceFittingsDetailModal: false,
      PositioningDeviceFittingsDetailModalId: null,
      // 添加设备配件
      AddPositioningDeviceFittingsModal: false,
      AddPositioningDeviceFittingsModalId: null,
      AddPositioningDeviceFittingsModalterminalNum: null,

      // 修改服务到费期
      modifyPositioningDeviceServiceDatetimeModal: false,
      modifyPositioningDeviceServiceDatetimeId: null,

      modify: false,
      positioningDeviceInfoStateOptions: [
        { label: '未安装', value: 1 },
        { label: '已安装', value: 2 },
        { label: '损坏', value: 3 }
      ],
      positioningDeviceModelOptions: [
        // { label: 'BSJ-A6-BD', value: 1 },
        // { label: 'BSJ-GF03', value: 2 },
        // { label: 'BSJ-M11', value: 3 },
        // { label: 'BSJ-A6L', value: 13 },
        // { label: 'BSJ-A7', value: 14 },
        // { label: 'K5', value: 4 },
        // { label: 'D5X', value: 5 },
        // { label: 'G-3G', value: 6 },
        // { label: 'D5X-HDD', value: 7 },
        // { label: 'D5X-XR', value: 8 },
        // { label: 'BSJ-GF06', value: 9 },
        // { label: 'BSJ-RM01', value: 10 },
        // { label: 'HIK-A3', value: 11 },
        // { label: 'HIK-A3L', value: 12 }
      ],
      positioningDeviceSourceTypeOptions: [
        { label: '新装', value: 1 },
        { label: '接入', value: 2 }
      ],
      positioningDeviceServiceStateOptions: [
        { label: '停止服务', value: 0 },
        { label: '服务中', value: 1 }
      ],
      positioningDeviceInfo: {
        id: null,
        terminalNum: null,
        factoryTerminalNum: null,
        positioningDeviceModelId: null,
        sourceType: null,
        serviceState: null,
        remark: null,
        setupDatetime: null,
        serviceDatetime: null,
        aisleOne: false,
        aisleTwo: false,
        aisleThree: false,
        aisleFour: false,
        aisleFive: false,
        aisleSix: false,
        aisleSeven: false,
        aisleEight: false,
        aisleNine: false,
        aisleTen: false
      }
    }
  },
  methods: {
    ...mapActions([
      'PositioningDeviceInfoServ_GetDetail',
      'PositioningDeviceInfoServ_ModifyObj'
    ]),
    handleCheckAll () {
      if (this.indeterminate) {
        this.checkAll = false
      } else {
        this.checkAll = !this.checkAll
      }
      this.indeterminate = false

      if (this.checkAll) {
        this.checkAllGroup = ['摄像头通道-1', '摄像头通道-2', '摄像头通道-3', '摄像头通道-4', '摄像头通道-5', '摄像头通道-6', '摄像头通道-7', '摄像头通道-8', '摄像头通道-9', '摄像头通道-10']
        this.positioningDeviceInfo.aisleOne = true
        this.positioningDeviceInfo.aisleTwo = true
        this.positioningDeviceInfo.aisleThree = true
        this.positioningDeviceInfo.aisleFour = true
        this.positioningDeviceInfo.aisleFive = true
        this.positioningDeviceInfo.aisleSix = true
        this.positioningDeviceInfo.aisleSeven = true
        this.positioningDeviceInfo.aisleEight = true
        this.positioningDeviceInfo.aisleNine = true
        this.positioningDeviceInfo.aisleTen = true
      } else {
        this.checkAllGroup = []
        this.positioningDeviceInfo.aisleOne = false
        this.positioningDeviceInfo.aisleTwo = false
        this.positioningDeviceInfo.aisleThree = false
        this.positioningDeviceInfo.aisleFour = false
        this.positioningDeviceInfo.aisleFive = false
        this.positioningDeviceInfo.aisleSix = false
        this.positioningDeviceInfo.aisleSeven = false
        this.positioningDeviceInfo.aisleEight = false
        this.positioningDeviceInfo.aisleNine = false
        this.positioningDeviceInfo.aisleTen = false
      }
    },
    checkAllGroupChange (data) {
      if (data.length === 10) {
        this.indeterminate = false
        this.checkAll = true
      } else if (data.length > 0) {
        this.indeterminate = true
        this.checkAll = false
      } else {
        this.indeterminate = false
        this.checkAll = false
      }
      //
      // data.forEach(item =>{
      //   console.log(item)
      //   if (item == '摄像头通道-1') {
      //     this.positioningDeviceInfo.aisleOne = true
      //   }else if (item == '摄像头通道-2') {
      //     this.positioningDeviceInfo.aisleTwo = true
      //   }else if (item == '摄像头通道-3') {
      //     this.positioningDeviceInfo.aisleThree = true
      //   }
      // })
    },

    modifyChange (status) {
      if (status === false) {
        this.$Modal.confirm({
          title: '确认修改定位设备信息',
          content: '<p>确认修改定位设备信息</p>',
          onOk: () => {
            if (this.positioningDeviceInfo.setupDatetime) {
              this.positioningDeviceInfo.setupDatetime = new Date(this.positioningDeviceInfo.setupDatetime)
            }
            store.dispatch('PositioningDeviceInfoServ_ModifyObj', {
              params: this.positioningDeviceInfo
            }).then(() => {
              this.$Message.success('修改成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          },
          onCancel: () => {
            let positioningDeviceInfoId = this._initValue
            store.dispatch('PositioningDeviceInfoServ_GetDetail', {
              params: { id: positioningDeviceInfoId }
            }).then(() => {
              this.positioningDeviceInfo = store.getters.get_PositioningDeviceInfo_GetDetailResult
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        })
      }
    },
    onSuccess () {
      this.visibleChange(true)
    },
    onPositioningdevicefittings () {
      let queryParams = []
      queryParams.push(genQueryParam('terminalNum', 'EQ', this.positioningDeviceInfo.terminalNum))
      store.dispatch('PositioningDeviceFittingsServ_GetAll', {
        params: null,
        urlparams: {
          q: queryParams
        }
      }).then(() => {
        console.log(store.getters.get_PositioningDeviceFittings_GetAllResult)
        this.positioningDeviceInfo.positioningDeviceFittingsId = store.getters.get_PositioningDeviceFittings_GetAllResult[0].id
        store.dispatch('PositioningDeviceInfoServ_BindPositioningDeviceFittings', {
          params: {
            id: this.positioningDeviceInfo.id,
            positioningdevicefittingsid: this.positioningDeviceInfo.positioningDeviceFittingsId
          },
          urlparams: null
        }).then(() => {
        }).catch(err => {
          this.$Message.error(err)
        })
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    onPositioningDeviceFittingsDetailModal () {
      console.log('ok')
      if (this.positioningDeviceInfo.positioningDeviceFittingsId == null) {
        this.AddPositioningDeviceFittingsModalId = this.positioningDeviceInfo.installOrderId
        this.AddPositioningDeviceFittingsModal = true
        this.AddPositioningDeviceFittingsModalterminalNum = this.positioningDeviceInfo.terminalNum
      } else {
        this.PositioningDeviceFittingsDetailModalId = this.positioningDeviceInfo.positioningDeviceFittingsId
        this.PositioningDeviceFittingsDetailModal = true
      }
    },
    visibleChange (val) {
      if (val) {
        this.modify = false
        this.positioningDeviceInfo.id = null
        this.positioningDeviceInfo.terminalNum = null
        this.positioningDeviceInfo.factoryTerminalNum = null
        this.positioningDeviceInfo.positioningDeviceModelId = null
        this.positioningDeviceInfo.sourceType = null
        this.positioningDeviceInfo.serviceState = null
        this.positioningDeviceInfo.remark = null
        this.positioningDeviceInfo.setupDatetime = null
        this.positioningDeviceInfo.serviceDatetime = null
        this.positioningDeviceInfo.aisleOne = false
        this.positioningDeviceInfo.aisleTwo = false
        this.positioningDeviceInfo.aisleThree = false
        this.positioningDeviceInfo.aisleFour = false
        this.positioningDeviceInfo.aisleFive = false
        this.positioningDeviceInfo.aisleSix = false
        this.positioningDeviceInfo.aisleSeven = false
        this.positioningDeviceInfo.aisleEight = false
        this.positioningDeviceInfo.aisleNine = false
        this.positioningDeviceInfo.aisleTen = false
        this.checkAllGroup = []
        let positioningDeviceInfoId = this._initValue
        if (positioningDeviceInfoId) {
          store.dispatch('PositioningDeviceInfoServ_GetPage', {
            urlparams: { q: genQueryParam('installOrderId', 'EQ', positioningDeviceInfoId) }
          }).then(() => {
            this.positioningDeviceInfo = store.getters.get_PositioningDeviceInfo_GetPageResult.content[0]
            if (this.positioningDeviceInfo.setupDatetime) {
              this.positioningDeviceInfo.setupDatetime = new Date(this.positioningDeviceInfo.setupDatetime)
            }
            if (this.positioningDeviceInfo.serviceDatetime) {
              this.positioningDeviceInfo.serviceDatetime = new Date(this.positioningDeviceInfo.serviceDatetime)
            }
            if (this.positioningDeviceInfo.aisleOne) {
              this.checkAllGroup.push('1')
            }else {
                this.positioningDeviceInfo.aisleOne = false
            }
            if (this.positioningDeviceInfo.aisleTwo) {
              this.checkAllGroup.push('2')
            }else {
                this.positioningDeviceInfo.aisleTwo = false
            }
            if (this.positioningDeviceInfo.aisleThree) {
              this.checkAllGroup.push('3')
            }else {
                this.positioningDeviceInfo.aisleThree = false
            }
            if (this.positioningDeviceInfo.aisleFour) {
              this.checkAllGroup.push('4')
            }else {
                this.positioningDeviceInfo.aisleFour = false
            }
            if (this.positioningDeviceInfo.aisleFive) {
              this.checkAllGroup.push('5')
            }else {
                this.positioningDeviceInfo.aisleFive = false
            }
            if (this.positioningDeviceInfo.aisleSix) {
              this.checkAllGroup.push('6')
            }else {
                this.positioningDeviceInfo.aisleSix = false
            }
            if (this.positioningDeviceInfo.aisleSeven) {
              this.checkAllGroup.push('7')
            }else {
                this.positioningDeviceInfo.aisleSeven = false
            }
            if (this.positioningDeviceInfo.aisleEight) {
              this.checkAllGroup.push('8')
            }else {
                this.positioningDeviceInfo.aisleEight = false
            }
            if (this.positioningDeviceInfo.aisleNine) {
              this.checkAllGroup.push('9')
            }else {
                this.positioningDeviceInfo.aisleNine = false
            }
            if (this.positioningDeviceInfo.aisleTen) {
              this.checkAllGroup.push('10')
            }else {
                this.positioningDeviceInfo.aisleTen = false
            }
          }).catch(err => {
            this.$Message.error(err)
          })
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        terminalNum: this.terminalNumRules
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
        store.dispatch('PositioningDeviceTypeServ_GetAll',{
            params:null,
            urlparams:null
        }).then(()=>{

            if (store.getters.get_PositioningDeviceType_GetAllResult) {
                store.getters.get_PositioningDeviceType_GetAllResult.forEach(item=>{
                    this.PositioningDeviceModellist.push({name: item.name, val: item.id},)
                })
            }
        }).catch(err=>{
            console.log(err)
        })
    })
  }
}
</script>
<style>
  .demo-split{
    height: 160px;
    /*border: 1px solid #dcdee2;*/
  }
  .demo-split-pane{
    padding: 10px;
  }

  .Checkbox{
    padding: 10px;
  }
</style>
